import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconFunnel = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M3 4h18l-7 8.5V19l-4 2v-8.5L3 4Z' />
    </g>
  </SDIcon>
)

export default IconFunnel
